<template>
    <div class="pa-5 compact-form" v-if="activeCompany">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Client ID" | t }}</v-col>
            <v-col cols="6"
                ><p class="text-field-item mt-2">
                    {{ activeCompany.client_id ? activeCompany.client_id : "-" }}
                </p></v-col
            >
            <v-btn v-if="this.$route.params.companyId !== 'new'" @click="generateNewClientId"
                >{{ "Generate" | t }}
            </v-btn>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3" v-if="this.$route.params.companyId !== 'new'"
                >{{ "API key" | t }}
            </v-col>
            <v-col cols="3">
                <v-text-field
                    :value="apiKey"
                    v-if="apiKey"
                    class="text-field-item mb-1"
                    id="clipboardToCopy"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
            <v-col>
                <v-btn class="ml-2" v-if="apiKey" @click="copyApiInput">{{ "Copy" | t }}</v-btn>
            </v-col>
            <v-col>
                <v-btn @click="handleGenerateNewApiKey" v-if="this.$route.params.companyId !== 'new'"
                    >{{ "Generate new" | t }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="4">{{ "Partner payment rights" | t }}</v-col>
            <v-col cols="5">
                <v-switch
                    class="ma-0 mt-1"
                    v-model="activeCompany.has_partner_payment"
                    color="primary"
                    :value="activeCompany.has_partner_payment"
                    @change="updateField($event, 'has_parnter_payment')"
                />
            </v-col>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon color="grey" dark v-bind="attrs" v-on="on">
                        mdi-information
                    </v-icon>
                </template>
                <span>{{ "Allow company to use /api/v1/partner-payment API" | t }}</span>
            </v-tooltip>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="4">{{ "Include payer IBAN to postback" | t }}</v-col>
            <v-col cols="6">
                <v-switch
                    class="ma-0 mt-1"
                    v-model="activeCompany.meta.postback.payer_iban"
                    color="primary"
                    :value="activeCompany.meta.postback.payer_iban"
                    @change="updateMetaPostbackField($event, 'payer_iban')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="4">{{ "Include payer name to postback" | t }}</v-col>
            <v-col cols="6">
                <v-switch
                    class="ma-0 mt-1"
                    v-model="activeCompany.meta.postback.payer_name"
                    color="primary"
                    :value="activeCompany.meta.postback.payer_name"
                    @change="updateMetaPostbackField($event, 'payer_name')"
                />
            </v-col>
        </v-row>

        <div v-for="(item, index) in activeCompanyBanks" :key="item.bank_id">
            <div v-if="item.name === 'Stripe'">
                <v-divider class="mt-3 mb-3" />
                <v-row>
                    <v-col class="pt-0 pb-0">
                        <v-checkbox
                            v-model="item.is_active"
                            @input="updateBankField($event, 'is_active', index)"
                            :label="`${!item.is_active ? 'Activate' : 'Deactivate'} Stripe payment method` | t"
                        />
                    </v-col>
                </v-row>
                <div v-if="item.is_active">
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ item.name }} {{ "public key" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="item.public_key"
                                @input="updateBankField($event, 'public_key', index)"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ item.name }} {{ "secret key" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="item.secret_key"
                                @input="updateBankField($event, 'secret_key', index)"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ item.name }} {{ "recipient name" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="item.recipient_name"
                                @input="updateBankField($event, 'recipient_name', index)"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div v-else-if="item.name === 'Placet'">
                <v-divider class="mt-3 mb-3" />
                <v-row>
                    <v-col class="pt-0 pb-0">
                        <v-checkbox
                            v-model="item.is_active"
                            @input="updateBankField($event, 'is_active', index)"
                            :label="`${!item.is_active ? 'Activate' : 'Deactivate'} Placet payment method` | t"
                        />
                    </v-col>
                </v-row>
                <div v-if="item.is_active">
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ item.name }} {{ "partner key" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="item.partner_key"
                                @input="updateBankField($event, 'partner_key', index)"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ item.name }} {{ "recipient name" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="item.recipient_name"
                                @input="updateBankField($event, 'recipient_name', index)"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div v-else>
                <v-divider class="mt-0 mb-1" />
                <v-row no-gutters>
                    <v-col class="ma-0 row-title">
                        <v-checkbox
                            v-model="item.is_active"
                            @input="updateBankField($event, 'is_active', index)"
                            :label="
                                `${!item.is_active ? 'Activate' : 'Deactivate'} ${item.name} ${item.country} (${
                                    item.swift
                                }) payment method`
                            "
                        />
                    </v-col>
                </v-row>
                <div v-if="item.is_active">
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ item.name }} {{ "recipient IBAN" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="item.recipient_iban"
                                @input="updateBankField($event, 'recipient_iban', index)"
                                class="text-field-item mb-1"
                                :rules="[ibanRule]"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mb-7" no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ item.name }} {{ "recipient name" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="item.recipient_name"
                                @input="updateBankField($event, 'recipient_name', index)"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
        <v-divider class="mt-3 mb-3" />

        <h3>{{ "Access origin" | t }}</h3>
        <v-row v-for="(url, idx) in activeCompanyOrigins" :key="url" class="align-baseline" no-gutters>
            <v-col>
                <v-text-field
                    :value="url"
                    :placeholder="appUrl"
                    class="text-field-item mb-1 mt-2"
                    dense
                    hide-details
                    outlined
                    @input="updateOriginField($event, idx)"
                />
            </v-col>
            <v-col :cols="1" style="text-align: center">
                <v-icon @click="handleOriginDeleteClick(idx)">delete</v-icon>
            </v-col>
        </v-row>
        <v-row>
            <v-spacer />
            <v-btn class="mr-3 mt-1" small @click="handleOriginAddClick">
                <v-icon>add</v-icon>
            </v-btn>
        </v-row>
        <v-divider class="mt-6 mb-3" v-if="activeCompanyOrigins && activeCompanyOrigins.length > 0" />

        <h3>{{ "Allowed IBANs" | t }}</h3>
        <v-row v-for="(iban, idx) in activeCompanyAllowedIbans" :key="iban" class="align-baseline" no-gutters>
            <v-col>
                <v-text-field
                    :value="iban"
                    :rules="[ibanRule]"
                    placeholder="EE381010220196205220"
                    class="text-field-item mb-1 mt-2"
                    dense
                    hide-details
                    outlined
                    @input="updateAllowedIbanField($event, idx)"
                />
            </v-col>
            <v-col :cols="1" style="text-align: center">
                <v-icon @click="handleAllowedIbanDeleteClick(idx)">delete</v-icon>
            </v-col>
        </v-row>
        <v-row>
            <v-spacer />
            <v-btn class="mr-3 mt-1" small @click="handleAllowedIbanAddClick">
                <v-icon>add</v-icon>
            </v-btn>
        </v-row>
        <v-divider class="mt-6 mb-3" />
        <h3>{{ "Embedded flow" | t }}</h3>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="4">{{ "Use embedded flow for Swedbank payments" | t }}</v-col>
            <v-col cols="6">
                <v-switch
                    class="ma-0 mt-1"
                    v-model="activeCompany.meta.embedded.payment.swedbank"
                    color="primary"
                    :value="activeCompany.meta.embedded.payment.swedbank"
                    @change="updateMetaEmbeddedPaymentField($event, 'swedbank')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="4">{{ "Use embedded flow for Swedbank bulk payments" | t }}</v-col>
            <v-col cols="6">
                <v-switch
                    class="ma-0 mt-1"
                    v-model="activeCompany.meta.embedded.bulk_payment.swedbank"
                    color="primary"
                    :value="activeCompany.meta.embedded.bulk_payment.swedbank"
                    @change="updateMetaEmbeddedBulkPaymentField($event, 'swedbank')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="4">{{ "Use embedded flow for LHV payments" | t }}</v-col>
            <v-col cols="6">
                <v-switch
                    class="ma-0 mt-1"
                    v-model="activeCompany.meta.embedded.payment.lhv"
                    color="primary"
                    :value="activeCompany.meta.embedded.payment.lhv"
                    @change="updateMetaEmbeddedPaymentField($event, 'lhv')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="4">{{ "Use embedded flow for LHV bulk payments" | t }}</v-col>
            <v-col cols="6">
                <v-switch
                    class="ma-0 mt-1"
                    v-model="activeCompany.meta.embedded.bulk_payment.lhv"
                    color="primary"
                    :value="activeCompany.meta.embedded.bulk_payment.lhv"
                    @change="updateMetaEmbeddedBulkPaymentField($event, 'lhv')"
                />
            </v-col>
        </v-row>
        <v-snackbar v-model="copy_message" color="success" bottom right :timeout="2500" elevation="24" value="true">
            <div style="display: flex">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Successfully copied" | t }}</div>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Store from "../../../store";
import settings from "@/settings";
import IBAN from "iban";

export default {
    name: "integration-info-edit-tab",
    data() {
        return {
            copy_message: false,
            ibanRule: value => {
                return IBAN.isValid(value) || "Invalid IBAN.";
            },
            appUrl: settings.api_url
        };
    },
    computed: {
        ...mapState([
            "activeCompany",
            "apiKey",
            "activeCompanyBanks",
            "activeCompanyOrigins",
            "activeCompanyAllowedIbans"
        ])
    },
    destroyed() {
        Store.commit("setApiKey", null);
    },
    methods: {
        ...mapMutations(['setActiveCompanyMetaPostbackProperty', 'setActiveCompanyMetaEmbeddedProperty']),
        ...mapActions(["generateNewClientId"]),
        updateField(value, field) {
            Store.commit("updateActiveCompanyProperty", { prop: field, value: value });
        },
        updateBankField(value, field, index) {
            Store.commit("updateActiveCompanyBankProperty", { prop: field, value: value, index: index });
        },
        async generateNewClientId() {
            await Store.dispatch("generateNewClientId", this.activeCompany.id);
        },
        async handleGenerateNewApiKey() {
            await Store.dispatch("generateNewApiKey", this.activeCompany.id);
            document.execCommand("copy");
            this.copy_message = true;
        },
        copyApiInput() {
            let copyText = document.querySelector("#clipboardToCopy");
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");
            this.copy_message = true;
        },
        handleOriginAddClick() {
            Store.commit("addNewCompanyOrigin");
        },
        handleOriginDeleteClick(index) {
            Store.commit("deleteCompanyOrigin", { index: index });
        },
        updateOriginField(value, index) {
            Store.commit("updateActiveCompanyOriginProperty", { value: value, index: index });
        },
        handleAllowedIbanAddClick() {
            Store.commit("addNewCompanyAllowedIban");
        },
        handleAllowedIbanDeleteClick(index) {
            Store.commit("deleteCompanyAllowedIban", { index: index });
        },
        updateAllowedIbanField(value, index) {
            Store.commit("updateActiveCompanyAllowedIbanProperty", { value: value, index: index });
        },
        updateMetaPostbackField(value, field) {
            this.setActiveCompanyMetaPostbackProperty({ prop: field, value: value });
        },
        updateMetaEmbeddedPaymentField(value, field) {
            this.setActiveCompanyMetaEmbeddedProperty({ prop: field, value: value, type: 'payment' });
        },
        updateMetaEmbeddedBulkPaymentField(value, field) {
            this.setActiveCompanyMetaEmbeddedProperty({ prop: field, value: value, type: 'bulk_payment'});
        },
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
